<template lang="pug">
div
  .odds.text-muted(v-if="this.vg1.includes(menu2)")
    i.fad.fa-lock-alt
  template(v-else)
    template(v-if="[45, 46, 49].includes(menu2)")
      .col
        .odd-box.locked
          i.fa-solid.fa-lock
    template(v-else)
      .odd-box.locked
        i.fa-solid.fa-lock
</template>

<script>
import config from "@/config";

export default {
  computed: {
    vg1() {
      return config.vg1;
    },
    menu2() {
      return this.$store.getters.menu2;
    }
  }
}
</script>